import Modal from 'antd/lib/modal/Modal';
import { observer } from 'mobx-react';
import { PureComponent } from 'react';
import modals from '../../stores/modals';

export interface ConfirmModalProps {
	title: string;
	text: string;
	okButton: string;
	onDismiss: () => void;
	onConfirm: () => void;
}

@observer
export default class ConfirmModal extends PureComponent<ConfirmModalProps> {
	static async prompt(title: string, text: string, okButton: string = 'Confirm'): Promise<boolean> {
		return new Promise<boolean>((resolve, reject) => {
			modals.show((close: () => void) => (
				<ConfirmModal
					title={title}
					text={text}
					okButton={okButton}
					onConfirm={() => {
						close();
						resolve(true);
					}}
					onDismiss={() => {
						close();
						resolve(false);
					}}
				/>
			));
		});
	}

	render() {
		return (
			<Modal
				okText={this.props.okButton}
				onCancel={() => this.props.onDismiss()}
				visible={true}
				closable={false}
				title={this.props.title}
				onOk={() => {
					this.props.onConfirm();
				}}
			>
				<div style={{ width: '100%' }}>{this.props.text}</div>
			</Modal>
		);
	}
}
